module.exports = __webpack_public_path__ + "img/selection.45f1b4f2.svg";